import { __spreadArrays } from "tslib";
export var signupEnabledLocales = [
    'en',
    'es',
    'fr',
    'pt',
    'de',
    'it',
    'ru',
    'pl',
    'ja',
    'ko',
    'nl',
    'da',
    'sv',
    'no',
    'he',
    'id',
    'sk',
    'vi',
    'cs',
    'bg',
    'th',
    'ar',
    'fi',
    'tr',
    'zh-Hans',
    'zh-Hant',
    'uk'
];
var deprecatedLocales = ['zh'];
export var systemSupportedLanguages = __spreadArrays(signupEnabledLocales, deprecatedLocales);
//# sourceMappingURL=system-supported-languages.enum.js.map